module.exports = __webpack_public_path__ + "static/media/emptystate.8a5de0eb.svg";